export default __webpack_public_path__ + "static/candypants-icon-24e2a83e0fcf3347e15405ae09ea3131.svg";